import { render } from "./GiveDishSumStat.vue?vue&type=template&id=27f7a694&scoped=true"
import script from "./GiveDishSumStat.vue?vue&type=script&lang=js"
export * from "./GiveDishSumStat.vue?vue&type=script&lang=js"

import "./GiveDishSumStat.vue?vue&type=style&index=0&id=27f7a694&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f7a694"]])

export default __exports__